// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../Booker.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../Booker.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.submit-button[data-v-d105915a] {
  width: 100%;
  padding: 9px 20px;
  height: 36px;
  background-color: #426a7f;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-sizing: border-box;
}
.submit-button[data-v-d105915a]:active:not(.submit-button--disabled):not(.submit-button--loading) {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 94, 184, 0.3);
}
.submit-button--disabled[data-v-d105915a],
.submit-button--loading[data-v-d105915a] {
  background-color: #BFC1C3;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.submit-button--loading[data-v-d105915a] {
  opacity: 0.8;
  cursor: wait;
}
.loading-spinner[data-v-d105915a] {
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading-spinner i[data-v-d105915a] {
  font-size: 16px;
}
.button-text[data-v-d105915a] {
  white-space: nowrap;
}

/* Focus styles for accessibility */
.submit-button[data-v-d105915a]:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 94, 184, 0.3);
}
.submit-button[data-v-d105915a]:focus:not(.submit-button--disabled):not(.submit-button--loading) {
  box-shadow: 0 0 0 3px rgba(0, 94, 184, 0.3), 0 4px 8px rgba(0, 94, 184, 0.3);
}
`, "",{"version":3,"sources":["webpack://./../Osc.Common/Frontend/passwords/components/submitbutton.vue"],"names":[],"mappings":";AA4CA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,sBAAA;AACA;AAGA;EACA,wBAAA;EACA,2CAAA;AACA;AAEA;;EAEA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AACA;AAEA;EACA,YAAA;EACA,YAAA;AACA;AAEA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACA;AAEA;EACA,eAAA;AACA;AAEA;EACA,mBAAA;AACA;;AAEA,mCAAA;AACA;EACA,aAAA;EACA,2CAAA;AACA;AAEA;EACA,4EAAA;AACA","sourcesContent":["<template>\r\n  <button\r\n    type=\"button\"\r\n    :disabled=\"disabled || loading\"\r\n    @click=\"handleClick\"\r\n    class=\"submit-button\"\r\n    :class=\"{ 'submit-button--loading': loading, 'submit-button--disabled': disabled }\"\r\n  >\r\n    <span v-if=\"loading\" class=\"loading-spinner\">\r\n      <i class=\"fas fa-spinner fa-spin\"></i>\r\n    </span>\r\n    <span class=\"button-text\">{{ loading ? 'Processing...' : text }}</span>\r\n  </button>\r\n</template>\r\n\r\n<script>\r\nexport default {\r\n  name: 'SubmitButton',\r\n  props: {\r\n    disabled: {\r\n      type: Boolean,\r\n      default: false\r\n    },\r\n    loading: {\r\n      type: Boolean,\r\n      default: false\r\n    },\r\n    text: {\r\n      type: String,\r\n      default: 'Submit'\r\n    }\r\n  },\r\n  emits: ['click'],\r\n  methods: {\r\n    handleClick() {\r\n      if (!this.disabled && !this.loading) {\r\n        this.$emit('click');\r\n      }\r\n    }\r\n  }\r\n};\r\n</script>\r\n\r\n<style scoped>\r\n.submit-button {\r\n  width: 100%;\r\n  padding: 9px 20px;\r\n  height: 36px;\r\n  background-color: #426a7f;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 5px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n\r\n.submit-button:active:not(.submit-button--disabled):not(.submit-button--loading) {\r\n  transform: translateY(0);\r\n  box-shadow: 0 2px 4px rgba(0, 94, 184, 0.3);\r\n}\r\n\r\n.submit-button--disabled,\r\n.submit-button--loading {\r\n  background-color: #BFC1C3;\r\n  cursor: not-allowed;\r\n  transform: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.submit-button--loading {\r\n  opacity: 0.8;\r\n  cursor: wait;\r\n}\r\n\r\n.loading-spinner {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.loading-spinner i {\r\n  font-size: 16px;\r\n}\r\n\r\n.button-text {\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Focus styles for accessibility */\r\n.submit-button:focus {\r\n  outline: none;\r\n  box-shadow: 0 0 0 3px rgba(0, 94, 184, 0.3);\r\n}\r\n\r\n.submit-button:focus:not(.submit-button--disabled):not(.submit-button--loading) {\r\n  box-shadow: 0 0 0 3px rgba(0, 94, 184, 0.3), 0 4px 8px rgba(0, 94, 184, 0.3);\r\n}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
